// Composant pour gérer le formulaire d'ajout d'événement

import { addEvent } from '../services/eventService.js';
import { saveSalaire } from '../services/salaireService.js';
import { initEventList } from './EventList/index.js';
import { updateCalculs } from '../services/calculService.js';
import { scrollToEvent } from '../ui-tools/scrollUtils.js';
import { splitEventByMonth } from '../ui-tools/monthsSplitter.js';

// Initialiser le formulaire d'événement
export function initEventForm() {
  const form = document.getElementById('add-event-form');

  if (form) {
    // Synchroniser la date de fin avec la date de début lorsque la date de début est modifiée
    const startDateInput = document.getElementById('event-start');
    const endDateInput = document.getElementById('event-end');

    if (startDateInput && endDateInput) {
      startDateInput.addEventListener('input', function() {
        // Toujours copier la date de début vers la date de fin
        endDateInput.value = this.value;
      });
    }

    form.addEventListener('submit', handleSubmit);
  }
}

/**
 * Gère la soumission du formulaire d'ajout d'événement
 * @param {Event} e - L'événement de soumission
 */
async function handleSubmit(e) {
  e.preventDefault();

  try {
    // Récupérer les valeurs des champs
    const startDateValue = document.getElementById('event-start').value;
    let endDateValue = document.getElementById('event-end').value;
    const titleValue = document.getElementById('event-title').value;
    const hoursValue = document.getElementById('event-hours').value;
    const statusValue = document.getElementById('event-status').value;
    const salaireValue = document.getElementById('event-salaire').value;

    // Validation basique
    if (!startDateValue || !hoursValue) {
      alert('Veuillez remplir tous les champs obligatoires');
      return;
    }

    // Toujours utiliser la date de début comme date de fin si vide ou incorrecte
    if (!endDateValue || new Date(endDateValue).getFullYear() < 1000) {
      endDateValue = startDateValue;
    }

    // Créer l'objet événement de base
    const baseEvent = {
      startDate: startDateValue,
      endDate: endDateValue,
      title: titleValue,
      hours: parseInt(hoursValue, 10),
      status: statusValue
    };

    // NOUVEAU : Diviser l'événement par mois si nécessaire
    const eventsToCreate = splitEventByMonth(baseEvent);

    const savedEvents = [];

    // Créer tous les événements
    for (const eventToCreate of eventsToCreate) {
      const savedEvent = await addEvent(eventToCreate);
      savedEvents.push(savedEvent);

      // Enregistrer le salaire (réparti proportionnellement si multi-mois)
      if (savedEvent && savedEvent.id && salaireValue) {
        const proportionalSalaire = eventsToCreate.length > 1
          ? (parseFloat(salaireValue) * savedEvent.hours / parseInt(hoursValue, 10)).toFixed(2)
          : salaireValue;
        await saveSalaire(savedEvent.id, proportionalSalaire);
      }
    }

    // Réinitialiser le formulaire
    e.target.reset();

    // Message de confirmation
    if (eventsToCreate.length > 1) {
      alert(`${eventsToCreate.length} événements créés avec succès (répartis par mois)`);
    }

    // Mettre à jour l'interface et défiler vers le premier nouvel événement
    await initEventList();

    // Défiler vers le premier événement créé
    if (savedEvents.length > 0 && savedEvents[0].id) {
      scrollToEvent(savedEvents[0].id);
    }

    await updateCalculs();
  } catch (error) {
    console.error('Erreur lors de l\'ajout de l\'événement:', error);
    alert('Une erreur est survenue lors de l\'ajout de l\'événement.');
  }
}

/**
 * Divise un événement en plusieurs événements si il s'étend sur plusieurs mois
 * @param {Object} event - L'événement à diviser
 * @returns {Array} Array d'événements (un par mois)
 */


